import React from "react";
import HeaderBar from "../components/HeaderBar";
import Sidebar from "../components/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinnerThird } from "@fortawesome/pro-regular-svg-icons";

function LoadingPage({ title = "Loading..." }) {
  return (
    <>
    <div className="flex">
      <div className="page relative flex justify-center items-center min-h-screen w-full">
        {/* Bakgrundsbild */}
        <img
          src="/assets/images/imageBG2.png"
          className="fixed inset-0 -z-10 object-cover w-full h-full opacity-25"
          alt="Background"
        />
        
        {/* Content */}
        <div className="text-center">
          <div className="relative w-16 h-16 flex items-center justify-center">
            <div className="absolute inset-0 animate-ping rounded-full bg-blue-500 opacity-75"></div>
            <div className="relative w-16 h-16 flex items-center justify-center rounded-full bg-blue-500 text-white">
              <FontAwesomeIcon icon={faSpinnerThird} className="text-white text-4xl animate-spin" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  );
}

export default LoadingPage;
